module.exports = __webpack_public_path__ + "img/image43.3c11e2dc.jpg";